import { useTranslation } from 'react-i18next'
import { useTheme } from 'styled-components'
import Tooltip from '~/components/Tooltip'
import { PriceImpactLevel, useSpotSwapPriceImpact } from '~/state/dex/hooks'

const PriceImpact: React.FC = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const priceImpactInfo = useSpotSwapPriceImpact()

  const priceImpactTextColor = {
    [PriceImpactLevel.POSITIVE]: theme.colors.alertVerifiedText,
    [PriceImpactLevel.WARN]: theme.colors.textCaption,
    [PriceImpactLevel.DANGER]: theme.colors.alertRiskText,
  }
  if (priceImpactInfo?.level === PriceImpactLevel.NORMAL) {
    return null
  }

  // Negative numbers have a minus sign
  const prefixText =
    priceImpactInfo?.level === PriceImpactLevel.POSITIVE ? '+' : ''

  return (
    <Tooltip
      placement="right"
      trigger="hover"
      title={
        <span style={{ fontSize: 12 }}>
          {t('spotswap_swap_price_impact_tooltip')}
        </span>
      }
    >
      <span
        style={{
          color: priceImpactTextColor[priceImpactInfo?.level],
        }}
      >
        {` ( ${prefixText}${priceImpactInfo?.priceImpactInPercent}% )`}
      </span>
    </Tooltip>
  )
}

export default PriceImpact
